import { render } from "./ExpansivePanel.vue?vue&type=template&id=5074335b&scoped=true"
import script from "./ExpansivePanel.vue?vue&type=script&lang=js"
export * from "./ExpansivePanel.vue?vue&type=script&lang=js"

import "./ExpansivePanel.vue?vue&type=style&index=0&id=5074335b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5074335b"]])

export default __exports__